import Seo from '@/components/shared/Seo';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import MobileHistoryLayout from '@/components/home/mobile/History/MobileHistoryLayout';
interface Props {
  orderId: string;
}
export default function HistoryPage(p: Props) {
  return <div className='w-full' data-sentry-component="HistoryPage" data-sentry-source-file="index.tsx">
      <Seo nofollow noindex title='Genius Trading | Assets' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      <FullScreenGuard data-sentry-element="FullScreenGuard" data-sentry-source-file="index.tsx">
        <MobileHistoryLayout orderId={p.orderId} data-sentry-element="MobileHistoryLayout" data-sentry-source-file="index.tsx" />
      </FullScreenGuard>
    </div>;
}